/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_BodyweightInputs */

const en_features_bodyweight = /** @type {(inputs: Features_BodyweightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bodyweight`)
};

const pl_features_bodyweight = /** @type {(inputs: Features_BodyweightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`masa ciała`)
};

/**
* | output |
* | --- |
* | "bodyweight" |
*
* @param {Features_BodyweightInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_bodyweight = /** @type {((inputs?: Features_BodyweightInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_BodyweightInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_bodyweight(inputs)
	return en_features_bodyweight(inputs)
});